import { Remark } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import { ColumnDef } from "@tanstack/react-table";
import moment from "moment";
import { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import UndoTrashIcon from "../../Icons/UndoTrashIcon";
import Button from "../Reusable/Button";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import Modal from "../Reusable/Modal";
import { classNames } from "../Reusable/DatePicker/helpers";

const TrashOrderList = ({
  handleUndoDelete,
  isLoading,
  openDeletePopup,
  setOpenDeletePopup,
  commentMethods,
  resetComment,
}: any) => {
  const [deleteOrder, setDeleteOrder] = useState(false);
  const [showReamarksPopup, setShowRemarksPopup] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState("");
  const [receiver, setReceiver] = useState("");
  const { setError, clearErrors } = useForm({});
  const [isactive, setISactive] = useState("admin");

  const handleRemarksClick = (orderId: string, receiverName: string) => {
    setSelectedOrder(orderId);
    setReceiver(receiverName);
    setShowRemarksPopup(true);
  };

  const defaultColumns = useMemo(
    (): ColumnDef<any, any>[] => [
      {
        header: "WayBill",
        accessorKey: "tracking_number",
        cell: ({ row, getValue }: any) => {
          return (
            <div className={tw`cursor-pointer`}>
              <p className={tw`whitespace-nowrap`}>{getValue() ?? "N/A"}</p>
              <p className={tw`text-xs text-gray-500`}></p>
            </div>
          );
        },
      },
      {
        header: "Date",
        accessorKey: "created",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              {getValue() ? (
                <p>{moment(getValue()).format("YY-MM-DD HH:mm:ss")}</p>
              ) : (
                "N/A"
              )}
            </>
          );
        },
      },
      {
        header: "Origin",
        accessorKey: "pickup_branch.name",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              <p className={tw`uppercase`}>{getValue()}</p>
              <p className={tw`text-xs text-primary`}>
                {row?.original?.pickup_branch?.warehouse?.name}
              </p>
            </>
          );
        },
      },
      {
        header: "Sender",
        accessorKey: "sender.full_name",
        cell: NACell,
      },
      {
        header: "Receiver",
        accessorKey: "receiver.full_name",
        cell: NACell,
      },
      {
        header: "Destination",
        accessorKey: "destination.name",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              <p className={tw`uppercase`}>{getValue()}</p>
              <p className={tw`text-xs text-primary`}>
                {row?.original?.destination_branch?.warehouse?.name}
              </p>
            </>
          );
        },
      },

      {
        header: "Piece",
        accessorKey: "piece",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              <p className={tw`cursor-pointer`}>{getValue() ?? 0.0}</p>
            </>
          );
        },
      },
      {
        header: "Remarks",
        accessorKey: "remark",
        cell: ({ row, getValue }: any) => (
          <button
            onClick={() =>
              handleRemarksClick(
                row?.original?.id,
                row?.original?.receiver.full_name
              )
            }
          >
            {getValue()} Remarks
          </button>
        ),
      },
      {
        header: "Status",
        accessorKey: "delivery_status.name",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              <p
                className={tw`uppercase px-1 text-center rounded-md`}
                style={{ background: row?.original?.delivery_status?.color }}
              >
                {getValue()}
              </p>
              <p className={tw`text-xs text-primary`}>
                {row?.original?.rider?.name}
              </p>
            </>
          );
        },
      },
      {
        header: "Action",
        accessorKey: "id",
        cell: ({ row, getValue }: any) => (
          <>
            <div className="">
              <button
                type="button"
                disabled={isLoading || false}
                onClick={() => {
                  setOpenDeletePopup(!openDeletePopup);
                  setDeleteOrder(row?.original?.id);
                }}
                className="focus:outline-none"
              >
                <UndoTrashIcon color={"var(--primary)"} />
              </button>
            </div>
          </>
        ),
      },
    ],
    [isLoading, openDeletePopup, setOpenDeletePopup]
  );
  const handleactiveButton = (button) => {
    setISactive(button);
  };
  const handleDeleteModalClose = () => {
    setOpenDeletePopup(!openDeletePopup);
    clearErrors("comment");
    resetComment();
  };

  return (
    <>
      <DataTable
        url={APIS.TRASH_OREDR}
        queryKey={"trash-order"}
        columns={defaultColumns}
        tableName={"trash-order-list"}
        params={{
          ...(isactive === "merchant" ? { merchant_orders: true } : null),
        }}
        actionMenu={
          <div>
            <div className={tw`flex  border mr-2  rounded-full`}>
              <button
                onClick={() => handleactiveButton("admin")}
                className={classNames(
                  isactive === "admin" ? tw`bg-primary text-white px-3` : tw``,
                  tw`focus:outline-none px-2 py-2 rounded-full`
                )}
              >
                Admin
              </button>
              <button
                onClick={() => handleactiveButton("merchant")}
                className={classNames(
                  isactive === "merchant"
                    ? tw`bg-primary text-white  px-3`
                    : tw``,
                  tw`focus:outline-none px-2 rounded-full  py-2`
                )}
              >
                Merchant
              </button>
            </div>
          </div>
        }
      />
      <Modal
        isOpen={openDeletePopup}
        setIsOpen={handleDeleteModalClose}
        title={""}
      >
        <>
          <div className={tw`flex flex-col justify-center items-center  h-fit`}>
            <p className={tw`text-lg font-semibold mb-4`}>
              Are you sure you want to restore ?
            </p>
            <form
              className={tw`flex flex-col gap-y-2`}
              autoComplete="off"
              onSubmit={commentMethods.handleSubmit((data: any) =>
                handleUndoDelete(data, deleteOrder, setError, clearErrors)
              )}
            >
              <textarea
                {...commentMethods.register("comment")}
                placeholder="Write a reason for undo..."
                rows={5}
                className={tw`border px-2 py-2 w-96 focus:outline-none`}
              ></textarea>
              {commentMethods.formState.errors?.comment && (
                <p className={tw`text-red-500 text-xs my-1`}>
                  {commentMethods.formState.errors?.comment?.message}
                </p>
              )}
              <div
                className={tw`mt-6 flex justify-center gap-x-6 items-center`}
              >
                <div className={tw`w-24`}>
                  <Button
                    label={"Yes"}
                    isLoading={isLoading}
                    // onClick={() => handleDelete(deleteOrder, setError)}
                  />
                </div>
                <div>
                  <button
                    type="button"
                    className={tw`w-full px-[24px] py-2 rounded  focus:outline-none bg-[#EEF5F4]`}
                    onClick={handleDeleteModalClose}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </>
      </Modal>
      <Modal
        isOpen={showReamarksPopup}
        setIsOpen={setShowRemarksPopup}
        title={"Remark"}
      >
        <div className={tw`w-[600px]`}>
          <Remark
            selectedOrder={selectedOrder}
            receiver={receiver}
            canInput={false}
          />
        </div>
      </Modal>
    </>
  );
};

export default TrashOrderList;
